module.exports = __webpack_public_path__ + "img/login_app_bg.c50cf28a.png";